export default __webpack_public_path__ + "static/media/try-bg.3d03926a.svg";